export default __webpack_public_path__ + "static/media/goUp.dafcc212.svg";